import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  ActivatedRoute,
  CanActivateChild
} from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';
import { TokenStorageService } from '../services/token-storage.service';
import * as jwt_decode from "jwt-decode";

@Injectable({
  providedIn: 'root'
})
export class AuthGuardLogin implements CanActivate {
  setCookiesInLocal = 0;
  cookiesArray = [];
  constructor(
    public router: Router,
    public loginService: LoginService,
    private token: TokenStorageService,
    public activatedRoute: ActivatedRoute
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let data: any;
    
    if(localStorage.getItem("loggedInUser") != null && this.token.getToken()){
        this.loginService.navigateToHomePage();
        return false;
    }

    if (localStorage.getItem('ssoData') && JSON.parse(localStorage.getItem('ssoData')).sso_enabled === "true") {
        if (document.cookie && this.setCookiesInLocal === 0) {
            const cookieProperties = ['Authorization_cookie', 'JSESSIONID_cookie', 'SessionIndex_cookie', 'NAMEID_cookie', 'IDTOKEN_cookie'];
            cookieProperties.forEach(element => {
                this.cookiesArray.push(document.cookie.match('(^|;)\\s*' + element + '\\s*=\\s*([^;]+)')?.pop() || '');
                document.cookie =
                    element + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.acordsolutions.net;";
            });

            if (this.cookiesArray[0]) {
                window.sessionStorage.setItem('AuthorizationD', this.cookiesArray[0]);
                window.sessionStorage.setItem('JSESSIONID', this.cookiesArray[1]);
                this.token.saveToken(this.cookiesArray[1]);
                localStorage.setItem('AuthorizationD', this.cookiesArray[0]);
                localStorage.setItem('JSESSIONID', this.cookiesArray[1]);
                localStorage.setItem('SessionIndex', this.cookiesArray[2]);
                localStorage.setItem('NAMEID', this.cookiesArray[3]);
                localStorage.setItem('idToken', this.cookiesArray[4]);
                let data = jwt_decode(this.cookiesArray[0]).userPayload;
                if (data.eulaEnabled === 'y' && (data.eulaAccepted === 'n' || !data.eulaAccepted)) {
                    this.router.navigate(['/EULA']);
                } else {
                    this.loginService.navigateToHomePage();
                }
                this.setCookiesInLocal++;
            } else {
                let ssoLoginUrl = this.getSSOLoginUrl();
                document.location.href = ssoLoginUrl; 
                return false;
            }
        }else{
            let ssoLoginUrl = this.getSSOLoginUrl();
            document.location.href = ssoLoginUrl;
            return false;
        }
    } else {
        if (!window.location.search.includes('errIns')) {
            try{
                data = await this.loginService.singleSignOnEnabled().toPromise();
                localStorage.setItem('ssoData', JSON.stringify(data.body));
                if (localStorage.getItem("loggedInUser") == null) {
                    if (!window.location.search.includes('errIns')) {
                        if (data.status === 200 && data.body.sso_enabled === "true") {
                            let ssoLoginUrl = this.getSSOLoginUrl();
                            document.location.href = ssoLoginUrl;
                            return false;
                        }
                    }
                    return true;
                }
            }catch(e){
                console.log(e);
                return true;
            }
        } else {
            return true;
        }
       return true;
    }

    if (localStorage.getItem("loggedInUser") != null) {
        let loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
        if (localStorage.getItem('ssoData') && JSON.parse(localStorage.getItem('ssoData')).sso_enabled === "true") {
            if (loggedInUser.userType) {
                this.loginService.navigateToHomePage();
            } else {
                let ssoLoginUrl = this.getSSOLoginUrl();
                document.location.href = ssoLoginUrl;
            }
            return false;
        }else if (!loggedInUser.userType && localStorage.getItem('ssoEnabled') === 'false') {
            if (loggedInUser.eulaEnabled === 'y' && (loggedInUser.eulaAccepted === 'n' || !loggedInUser.eulaAccepted)) {
                this.router.navigate(['/EULA']);
            } else {
                this.loginService.navigateToHomePage();
            }
            return false;
        }else {
            return true;
        }
    }
  }
 
  
  getSSOLoginUrl(){ 
      let redirectURL = this.loginService.getRedirectUrl();
      if(redirectURL && redirectURL!="/" && redirectURL!="/login" && redirectURL!="/logout"){
          redirectURL="/#"+redirectURL;
      }else{
          redirectURL="";
      }
      let hostname = localStorage.getItem('hostname') ? localStorage.getItem('hostname') : window.location.origin;
      //for local sso
      if(window.location && window.location.host && window.location.host=='localhost.acordsolutions.net'){
          hostname='https://dev-transcriber-svc.acordsolutions.net';
      }
      let domainName = hostname.split('//')[1];

      let ssoDataStr = localStorage.getItem('ssoData');
      let ssoUrlType = 'saml2';
      if(ssoDataStr){
          let ssoData = JSON.parse(ssoDataStr);
          if(ssoData && ssoData.sso_type=='oidc'){
              ssoUrlType = 'oidc';
          }
      }
      let relayState = encodeURIComponent(hostname+redirectURL);
      //for local sso
      if(window.location && window.location.host && window.location.host=='localhost.acordsolutions.net'){
        domainName='dev-transcriber-svc.acordsolutions.net';
        relayState = encodeURIComponent('https://localhost.acordsolutions.net/'+redirectURL);
      }
      let ssoLoginUrl = `${hostname}/transcriber-sso/public/v1/sso/${ssoUrlType}/login?domainName=${domainName}&relayState=${relayState}`; 
      return ssoLoginUrl;
  }
}

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  setCookiesInLocal = 0;
  cookiesArray = [];
  constructor(
    public router: Router,
    public loginService: LoginService,
    private token: TokenStorageService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (document.cookie && this.setCookiesInLocal === 0) {
        const cookieProperties = ['Authorization_cookie', 'JSESSIONID_cookie', 'SessionIndex_cookie', 'NAMEID_cookie', 'IDTOKEN_cookie'];
        cookieProperties.forEach(element => {
            this.cookiesArray.push(document.cookie.match('(^|;)\\s*' + element + '\\s*=\\s*([^;]+)')?.pop() || '');
            document.cookie =
                element + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.acordsolutions.net;";
        });

        if (this.cookiesArray[0]) {
            window.sessionStorage.setItem('AuthorizationD', this.cookiesArray[0]);
            window.sessionStorage.setItem('JSESSIONID', this.cookiesArray[1]);
            this.token.saveToken(this.cookiesArray[1]);
            localStorage.setItem('AuthorizationD', this.cookiesArray[0]);
            localStorage.setItem('JSESSIONID', this.cookiesArray[1]);
            localStorage.setItem('SessionIndex', this.cookiesArray[2]);
            localStorage.setItem('NAMEID', this.cookiesArray[3]);
            localStorage.setItem('idToken', this.cookiesArray[4]);
            let redirectUrl = this.loginService.getRedirectUrl();
            if(!redirectUrl){
                this.loginService.setRedirectUrl(state.url);
            }
            this.setCookiesInLocal++;
            let data = jwt_decode(this.cookiesArray[0]).userPayload;            
            if (data.eulaEnabled === 'y' && (data.eulaAccepted === 'n' || !data.eulaAccepted)) {
                this.router.navigate(['/EULA']);
            } else {
                this.loginService.navigateToHomePage();
            }
            return false;
        }
    }

    if (this.token.getToken() !== null) {
      return true;
    } else {
      let redirectUrl = this.loginService.getRedirectUrl();
      if(!redirectUrl){
        this.loginService.setRedirectUrl(state.url);
      }
      this.router.navigate(['/login']);
      return false;
    }
  }
}
